export var global = typeof window !== 'undefined' ? window : {};



// WEBPACK FOOTER //
// ./node_modules/@juggle/resize-observer/lib/utils/global.js